import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const AnObjectSectionList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="anObjectSection"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default AnObjectSectionList;
